import { get, pickBy } from 'lodash';
import { getSafeMessageBody } from '../sagas/utils/utils';

export const generateTaskBackendParams = params => {
  const fields = {
    summary: get(params, 'summary'),
    skill_group_id: Number(get(params, 'skillGroupId')),
    description: get(params, 'description'),
    assignee_id: get(params, 'assigneeId'),
    priority: get(params, 'priority'),
    tag_ids: get(params, 'tagIds'),
    started_at: get(params, 'startedAt'),
    ended_at: get(params, 'endedAt'),
    status: get(params, 'status'),
  };
  return pickBy(fields, v => v !== undefined);
};

export const serializeTask = task => {
  const id = get(task, 'id');
  const assigneeId = get(task, 'assignee_id');
  const skillGroupId = get(task, 'skill_group_id');
  const relations = get(task, 'relations');
  const reminders = get(task, 'reminders');
  const tagIds = get(task, 'tag_ids');

  return {
    id: id && String(id),
    assigneeId: assigneeId && String(assigneeId),
    skillGroupId: skillGroupId && String(skillGroupId),
    attachments: get(task, 'attachments'),
    description: get(task, 'description'),
    endedAt: get(task, 'ended_at'),
    priority: get(task, 'priority'),
    relations: relations && serializeRelations(relations),
    reminders: reminders && serializeReminders(reminders),
    startedAt: get(task, 'started_at'),
    status: get(task, 'status'),
    summary: get(task, 'summary'),
    tagIds: tagIds && tagIds.map(tagId => String(tagId)),
  };
};

export const serializeTasks = tasks => tasks.map(task => serializeTask(task));

export const serializeRelation = relation => ({
  id: String(get(relation, 'id')),
  targetId: String(get(relation, 'target_id')),
  relationType: get(relation, 'relation_type'),
  summary: get(relation, 'summary'),
  type: get(relation, 'type'),
});

export const prepareReminderForBackend = reminder => ({
  id: Number(get(reminder, 'id')),
  remind_at: get(reminder, 'remindAt'),
});

export const serializeReminder = reminder => ({
  id: String(get(reminder, 'id')),
  remindAt: get(reminder, 'remind_at'),
});

export const serializeRelations = relations =>
  relations.map(relation => serializeRelation(relation));

export const serializeReminders = reminders =>
  reminders.map(reminder => serializeReminder(reminder));

export const serializeMetaInfo = meta => ({
  page: get(meta, 'page'),
  size: get(meta, 'size'),
  total: get(meta, 'total'),
  totalPages: get(meta, 'total_pages'),
});

export const serializeTaskLog = log => {
  const relatedId = get(log, 'related_id');

  return {
    id: String(get(log, 'id')),
    createdAt: get(log, 'created_at'),
    eventType: get(log, 'event_type'),
    fieldName: get(log, 'field_name'),
    managerId: String(get(log, 'manager_id')),
    newValue: get(log, 'new_value'),
    oldValue: get(log, 'old_value'),
    relatedId: relatedId && String(relatedId),
    relatedType: get(log, 'related_type'),
    relationType: get(log, 'relation_type'),
  };
};

export const serializeTaskLogs = logs => logs.map(log => serializeTaskLog(log));

export const serializeTaskEntity = task => ({
  id: String(task.id),
  description: task.summary,
});
export const serializeTaskEntities = tasks =>
  tasks.map(task => serializeTaskEntity(task));

export const serializeTicketEntity = ticket => ({
  id: String(ticket.id),
  description: ticket.subject,
});
export const serializeTicketEntities = tickets =>
  tickets.map(ticket => serializeTicketEntity(ticket));

export const serializeOrderEntity = order => ({
  id: String(order.id),
  description: `${order.client_full_name} ${order.hotel_name}`,
});
export const serializeOrderEntities = orders =>
  orders.map(order => serializeOrderEntity(order));

export const serializeTaskComment = comment => {
  return {
    id: String(get(comment, 'id')),
    authorId: String(get(comment, 'author_id')),
    createdAt: get(comment, 'created_at'),
    text: getSafeMessageBody(get(comment, 'text')),
    summonees: get(comment, 'summonees').map(summonee => String(summonee)),
  };
};
export const sortComments = comments => {
  if (!comments && comments.length <= 0) return null;

  return comments.sort((a, b) => a.id - b.id);
};

export const serializeTaskComments = comments =>
  sortComments(comments.map(log => serializeTaskComment(log)));
